import React from "react";
import { TitleProps } from "../models/types/TitleProps.type";

export default function Title(props: TitleProps) {
  const { titulo } = props;
  return <h1>{titulo}</h1>;
}
